import React, { Component, PropTypes } from 'react'
import styled from 'styled-components'
import R from 'ramda'
import CardContainer from '../../components/CardContainer'
import { searchContinents } from '../../sources/SearchSource'
import {
  updateContinent,
  deleteContinent,
  createContinent
} from '../../sources/AdminSource'
import { translate } from 'react-i18next'
import Grid from 'grid-styled'
import ThemeContainer from '../../components/ThemeContainer'
import AdminNavbar from '../../components/AdminNavbar'
import { Metrics, Fonts, Colors } from '../../Themes'
import BackArrow from '../../svg-icons/BackArrow'
import Edit from '../../svg-icons/Edit'
import Add from '../../svg-icons/Add'
import TextArea from '../../components/Textarea'
import UploadPicture from '../../components/UploadPicture'
import Input from '../../components/Input'
import SuccessModal from '../../components/Modal/SuccessModal'
import ErrorModal from '../../components/Modal/ErrorModal'
import DialogModal from '../../components/Modal/DialogModal'
import { continentDefault } from '../../Utils/Defaults'

const Container = styled.div`
  max-height: ${Metrics.components.adminContent};
  overflow-y: scroll;
`

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const BackArrowContainer = styled.div`
  margin: ${Metrics.margins.base} 0;
  cursor: pointer;
  span {
    margin-left: ${Metrics.margins.base};
    ${Fonts.style.Header};
  }
`

const Picture = styled.div`
  height: 136px;
  width: 136px;
  background: ${props =>
    props.imageSrc
      ? `url('${props.imageSrc}') no-repeat center`
      : Colors.lightGrey};
  background-size: cover;
  position: relative;
`

const EditIcon = styled.div`
  background: ${Colors.lightGrey};
  width: 40px;
  height: 40px;
  position: absolute;
  cursor: pointer;
  right: -${Metrics.margins.base};
  bottom: -${Metrics.margins.base};
  border-radius: 50%;
  svg {
    margin: 8px;
    #icon-outline {
      fill: ${Colors.white};
    }
  }

  &:hover {
    background: ${Colors.darkGrey};
  }
`

const ImportPicture = styled.div`
  ${Fonts.style.Text};
  color: ${Colors.white};
  margin: 0 auto;
  text-align: center;
  padding: ${Metrics.margins.larger};
  cursor: pointer;

  svg {
    margin: 0 auto;
    margin-bottom: ${Metrics.margins.medium};
    display: block;
    #plus-icon {
      fill: ${Colors.white};
    }
  }
`

const CustomGrid = styled(Grid)`
  padding-left: ${props => (props.noPadLeft ? 0 : Metrics.margins.small)};
  padding-right: ${props => (props.noPadRight ? 0 : Metrics.margins.small)};
  margin-top: ${props => (props.noPadTop ? 0 : Metrics.margins.base)};
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding: 0 32px !important; 
`

const Error = styled.div`
  ${Fonts.style.Input};
  margin-top: ${Metrics.margins.tiny};
  color: ${Colors.red};
`

class EditPictures extends Component {
  constructor (props) {
    super(props)
    this.state = {
      continent: R.clone(continentDefault),
      imageError: '',
      modal: '',
      create: false
    }
    this.handleUpload = this.handleUpload.bind(this)
    this.handleUpdate = this.handleUpdate.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleDeleteContinent = this.handleDeleteContinent.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.handleError = this.handleError.bind(this)
  }

  componentWillMount () {
    const { params } = this.props
    if (params.id !== 'new') {
      searchContinents({ id: params.id })
        .then(response => this.setState({ continent: response.data }))
        .catch(error => console.log(error))
    } else {
      this.setState({ create: true })
    }
  }

  handleUpload (file, result) {
    const { continent } = this.state
    continent.picture = { file: file, result: result }
    this.setState({ continent, imageError: null })
  }

  handleUpdate () {
    const { continent, create } = this.state
    if (create) {
      createContinent(continent)
        .then(response => {
          let continentCreated = response.data[0] || response.data
          this.setState({ continent: continentCreated, modal: 'success' })
        })
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    } else {
      updateContinent(continent)
        .then(response => {
          this.setState({ continent: response.data, modal: 'success' })
        })
        .catch(error => {
          console.log(error)
          this.setState({ modal: 'error' })
        })
    }
  }

  handleDeleteContinent () {
    deleteContinent(this.state.continent.id)
      .then(response => this.props.router.goBack())
      .catch(error => {
        console.log(error)
        this.setState({ modal: 'error' })
      })
  }

  handleChange (event, key) {
    const { continent } = this.state
    continent[key] = event.target.value
    this.setState({ continent })
  }

  toggleModal (modal) {
    this.setState({ modal })
  }

  handleError () {
    const { t } = this.props
    this.setState({
      imageError: t('Image too large (2MB max) or has an invalid type')
    })
  }

  render () {
    const { t, router, admin, dropdownLinks } = this.props
    const { continent, modal, imageError, create } = this.state
    const adminActions = [
      { label: t('Save'), secondary: true, onClick: this.handleUpdate }
    ]
    if (!create) {
      adminActions.push({
        label: t('Delete Continent'),
        cancel: true,
        onClick: () => this.toggleModal('dialog')
      })
    }
    return (
      <div>
        <AdminNavbar
          admin={admin}
          dropdownLinks={dropdownLinks}
          fixedSearchBar
          rightSideActions={adminActions}
        />
        <SuccessModal
          visible={modal === 'success'}
          message={t(
            `Continent successfuly ${create ? 'created' : 'updated'}.`
          )}
          header={t(`Continent ${create ? 'Created' : 'Updated'}`)}
          closeAction={this.toggleModal}
        />
        <ErrorModal
          visible={modal === 'error'}
          message={t(
            `There was a problem when ${create
              ? 'creating'
              : 'updating'} the continent.`
          )}
          header={t('Error')}
          closeAction={this.toggleModal}
        />
        <DialogModal
          visible={modal === 'dialog'}
          message={t('Do you want to delete this continent?')}
          header={t('Delete Continent')}
          closeAction={this.toggleModal}
          buttons={{
            apply: {
              label: 'Cancel',
              onClick: this.toggleModal
            },
            cancel: {
              label: 'Delete',
              onClick: this.handleDeleteContinent
            }
          }}
        />
        <Container>
          {continent && (
            <CustomThemeContainer>
              <BackArrowContainer>
                <BackArrow onClick={() => router.goBack()} />
                <span className='name'>
                  {create ? t('Insert Continent') : continent.name}
                </span>
              </BackArrowContainer>
              <CustomCardContainer
                title={
                  create ? t('Create New Continent') : t('Edit Continent')
                }>
                <CustomGrid noPadTop noPadLeft noPadRight>
                  <Input
                    value={continent.name}
                    title={t('Continent')}
                    handleChange={event => this.handleChange(event, 'name')}
                    placeholder={t('Continent Name')}
                  />
                </CustomGrid>
                <CustomGrid noPadLeft noPadRight>
                  <TextArea
                    title={t('Description')}
                    value={continent.description}
                    handleChange={event =>
                      this.handleChange(event, 'description')}
                    placeholder={t('Country description')}
                  />
                </CustomGrid>
                <CustomGrid noPadLeft noPadRight>
                  <Picture
                    imageSrc={
                      (continent.picture && continent.picture.result) ||
                      continent.picture
                    }>
                    <UploadPicture
                      uploadButton={
                        continent.picture ? (
                          <EditIcon>
                            <Edit />
                          </EditIcon>
                        ) : (
                          <ImportPicture>
                            <Add />
                            {t('Import Picture')}
                          </ImportPicture>
                        )
                      }
                      handleError={this.handleError}
                      handleUploaded={this.handleUpload}
                    />
                  </Picture>
                  {imageError && <Error>{imageError}</Error>}
                </CustomGrid>
              </CustomCardContainer>
            </CustomThemeContainer>
          )}
        </Container>
      </div>
    )
  }
}

EditPictures.propTypes = {
  router: PropTypes.object,
  params: PropTypes.object,
  t: PropTypes.func,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(EditPictures)



// WEBPACK FOOTER //
// ./src/pages/AdminLocations/EditContinent.js